
import {Injectable} from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { eHome365DisplayFile } from '../enums';
import { NetService } from './net.service';
import { environment } from '../../../environments/environment';
import { Home365DisplayFileModel } from '../classes';


interface UploadOptions {
  maxSize?: {value: number, error: string},
  acceptedTypes?: {value: string[], allowImg: boolean, error: string}
}
export interface UploadFileResponse {
  fileType: eHome365DisplayFile;
  displayName?: string;
  src: string;
  img?: boolean;
  pdf?: boolean;
}
export interface UploadResponse {
  ok: boolean,
  error?: string,
  uploadResponse?: Promise<any>
}
const ConstantVariable = {
  cdnImages: `https://d2idjfaj943a7l.cloudfront.net/${environment.aws.foleder_files}`
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private netService: NetService
  ) { }


  uploadMultiFiles(files: FileList) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    formData.append('folderName', environment.aws.folder)
    return this.netService.postJavaMultipleFiles(`upload-bulk-multipart-file-toS3`, formData);
  }

  uploadS3(file: any, uploadOptions: any, fileNamePrefix = null): UploadResponse {
    if (uploadOptions) {
      if (this.isFileUnderSize(file.size, uploadOptions.maxSize)) {
        if (this.isCorrectType(file, uploadOptions.acceptedTypes)) {
          return {ok: true, uploadResponse: this.uploadFileToS3(file, fileNamePrefix)};
        } else {
          return {error: uploadOptions.acceptedTypes.error, ok: false};
        }
      } else {
        return {error: uploadOptions.maxSize.error, ok: false};
      }
    }
    return {ok: true, uploadResponse: this.uploadFileToS3(file, fileNamePrefix)};
  }

  private isFileUnderSize(size: any, maxSize: any) {
    return !maxSize || (maxSize && size <= maxSize.value);
  }
  private isCorrectType(file: any, acceptedTypes?: {value: string[], allowImg: boolean, error: string}) {
    if (acceptedTypes) {
      const type = file.name.split('.').pop();
      if (acceptedTypes.value.includes(type)) {
        return true;
      }
      if (acceptedTypes.allowImg) {
        return this.isFileImg(file);
      }
      return false;
    }
    return true;
  }
  isFileImg(file: any) {
    const fileType = file.type.split('/');
    return fileType[0] === 'image';
  }
  private async uploadFileToS3(file: any, fileNamePrefix = null): Promise<any> {
    const type = file.name.split('.').pop();
    const fileData: any = {
      name: fileNamePrefix === null ? this.createGuid() + '.' + type :
        fileNamePrefix + this.createGuid() + '.' + type,
      src: null
    };
    const {bucket, params} = this.getBucket(file, fileData.name);
    const upload = bucket.upload(params);
    fileData.src = ConstantVariable.cdnImages + fileData.name;
    return upload.promise().then(res => {
      return {...res, src: ConstantVariable.cdnImages + fileData.name};
    });
  }

  createGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  private getBucket(file: any, fileName: string) {
    return {bucket: new S3({
      accessKeyId: environment.aws.accessKeyId,
      secretAccessKey: environment.aws.secretAccessKey,
      region: environment.aws.region
    }), params: {
      Bucket: 'frontdoorapp',
      Key: environment.aws.foleder_files + fileName,
      Body: file,
      ACL: 'public-read',
    }};
  }

  getFileObject(url: string): Home365DisplayFileModel| null {
    if (!url) {
      return null;
    }
    const type = url.split('.');
    if (type.pop() === 'pdf') {
      return {
        displayName: 'Download invoice attachment',
        pdf: true,
        src: url
      };
    } else {
      return {
        img: true,
        src: url,
        fileType: eHome365DisplayFile.img
      };
    }
  }

  getFilePlaceHolder(): UploadFileResponse | null {
    return null
  }
}
